import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import styles from '../SelectLocation/SelectLocation.module.css';
import iconBack from '../../../../images/icon-chevron-left.svg';
import { AnyIfEmpty, useDispatch, useSelector } from 'react-redux';
import { getLocationById } from '../../../../redux/location/actions/location.action';
import { AppDispatch, IRootState } from '../../../../redux/rootReducer';
import TinyLoader from '../../../common/tiny-loader/TinyLoader';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';

interface AddAvailabilityObjProps {
    closingTime: string;
    endDate: string;
    locationId: string;
    locationName: string;
    locker: number | null;
    openingTime: string;
    startDate: string;
    unitId: string;
    unitName: string;
}
interface props {
    setShowLocation: (active: boolean) => void;
    setShowUnits: (active: boolean) => void;
    setShowLocker: (active: boolean) => void;
    locationId: string;
    setAddAvailabilityObj: Dispatch<SetStateAction<AddAvailabilityObjProps>>;
    addAvailabilityObj: AddAvailabilityObjProps;
}

const SelectUnit = ({ setShowLocation, setShowUnits, setShowLocker, locationId, setAddAvailabilityObj, addAvailabilityObj }: props) => {
    const dispatch: AppDispatch = useDispatch();

    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    const locationById = useSelector((state: IRootState) => state?.locationReducer?.location?.data?.location);
    const loading = useSelector((state: IRootState) => state.locationReducer.location.loading);

    useEffect(() => {
        dispatch(getLocationById(locationId));
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div
                    className={styles.back}
                    onClick={() => {
                        setShowUnits(false);
                        setShowLocation(true);
                    }}>
                    <img src={iconBack} alt="back" />
                </div>
                <h2 className={styles.title}>Units</h2>
            </div>
            <div className={styles.body}>
                <h3 className={styles.subTitle}>Select a unit</h3>
                <div className={styles.tabs}>
                    {loading ? (
                        <TinyLoader />
                    ) : (
                        locationById?.units?.map((unit: AnyIfEmpty<object>) => (
                            <span
                                onClick={() => {
                                    availabilityRedirectionContext?.setAvailabilityData({
                                        locationId: '',
                                        locationName: '',
                                        selectedDate: '',
                                        slotRange: '',
                                        unitId: '',
                                        unitName: '',
                                        lockerNumber: 0,
                                    });
                                    setAddAvailabilityObj((prevState) => {
                                        return {
                                            ...prevState,
                                            unitId: unit.id,
                                            unitName: unit?.unitYardiId ? unit?.unitYardiId : unit.name,
                                            locker: prevState.unitId === unit.id ? addAvailabilityObj.locker : null,
                                        };
                                    });
                                    setShowUnits(false);
                                    setShowLocker(true);
                                }}
                                key={unit.id}
                                className={unit.id === addAvailabilityObj.unitId ? styles.selected : styles.tab}>
                                {unit.unitYardiId ? unit.unitYardiId : unit.name}
                            </span>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default SelectUnit;
